import { Injectable } from '@angular/core';
import { INomenclatureResponse, observeTypes } from '@app/shared/interfaces/response-interfaces';
import { Observable } from 'rxjs';
import { AppConfig } from '@app/config/app.config';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorHandler, HandleError } from '@app/shared/services/http-error-handler.service';
import { LoggerService } from '@app/shared/services/logger.service';
import { HeadersSetterHelper } from '@app/shared/helpers/http-headers-setter-helper';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class NomenclatureService {
  private handleError: HandleError;
  private headerHelper: HeadersSetterHelper;

  constructor(
    private httpErrorHandler: HttpErrorHandler,
    private http: HttpClient,
    private store: Store<any>,
    private logger: LoggerService) {
    this.handleError = httpErrorHandler.createHandleError('NomenclatureService');
    this.headerHelper = new HeadersSetterHelper(this.store);
  }

  get(): Observable<INomenclatureResponse> {
    const url = AppConfig.endpoints.order.nomenclature;
    return this.http.get<INomenclatureResponse>(url, this.headerHelper.options(observeTypes.BODY))
      .pipe(
        catchError(this.handleError('getNomenclature')),
        map((res: INomenclatureResponse) => {
          this.logger.log(res);
          return res;
        })
      );
  }

  

}
